import { useState } from "react";
import { Button, TextField } from "@mui/material";
import SimpleSelect from "./SimpleSelect";

/* Générateur de liens de campagne (offre §2.5) : l'adresse de la soirée sur le nouveau site, étiquetée UTM.
   utm_campaign sert aussi d'origine des ventes dans Weezevent (le site la transmet au module de billetterie).
   Même slug que le site : titre sans accents + date (dclub-front, lib/soiree.ts). */
const SOURCES = {
  instagram: "Instagram",
  facebook: "Facebook",
  newsletter: "Newsletter",
  affiche: "Affiche (QR code)",
  autre: "Autre",
};
type Source = keyof typeof SOURCES;
const MEDIUM: { [key in Source]: string } = {
  instagram: "social",
  facebook: "social",
  newsletter: "email",
  affiche: "print",
  autre: "referral",
};

const slugify = (s: string) =>
  s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "soiree";

const decode = (html: string) => new DOMParser().parseFromString(html, "text/html").documentElement.textContent ?? html;

export default function CampaignLink({ title, ymd }: { title: string; ymd: string }) {
  const [source, setSource] = useState<Source | undefined>("instagram");
  const [copied, setCopied] = useState(false);
  if (!ymd || !title) return null;
  const slug = `${slugify(decode(title).trim())}-${ymd.slice(6, 8)}-${ymd.slice(4, 6)}-${ymd.slice(0, 4)}`;
  const s = source ?? "autre";
  const url = `https://dclub.ch/soiree/${slug}?utm_source=${s}&utm_medium=${MEDIUM[s]}&utm_campaign=${slug}`;
  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      <SimpleSelect options={SOURCES} value={source} setValue={setSource} label="Lien de campagne pour" />
      <TextField variant="filled" label="Lien à coller (Meta, newsletter…)" value={url} InputProps={{ readOnly: true }} style={{ flex: 1, minWidth: 260 }} />
      <Button
        variant="outlined"
        onClick={() => navigator.clipboard.writeText(url).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); })}
      >
        {copied ? "Copié" : "Copier"}
      </Button>
    </div>
  );
}
